// removed by extract-text-webpack-plugin
module.exports = {"days":"Days-days","selected":"Days-selected","today":"Days-today"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwdatepicker/Days.scss
// module id = 361
// module chunks = 0